// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'
import { toAdminListParams } from '@/core/lib/table-query'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import { teamLogoListQueryOptions } from '@/modules/team-logo/team-logo.hooks'
import { teamLogoSearchSchema } from '@/modules/team-logo/team-logo.schemas'

export const teamLogoRoute = createRoute({
  path: '/team-logos',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const teamLogoListRoute = createRoute({
  getParentRoute: () => teamLogoRoute,
  path: '/',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'teams.list',
      'Takım logoları listesine erişim izniniz yok.'
    )
  },
  head: () => ({
    meta: [{ title: 'Takım Logoları' }],
  }),
  validateSearch: teamLogoSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    await queryClient.ensureQueryData(
      teamLogoListQueryOptions(toAdminListParams(deps))
    )
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/team-logo/pages/list-team-logo.page')
  ),
})

export const teamLogoCreateRoute = createRoute({
  getParentRoute: () => teamLogoRoute,
  path: '/create',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'teams.edit',
      'Takım logosu oluşturmak için yetkiniz yok.'
    )
  },
  head: () => ({
    meta: [{ title: 'Takım Logosu Oluştur' }],
  }),
  component: lazyRouteComponent(
    () => import('@/modules/team-logo/pages/create-team-logo.page')
  ),
})

export const teamLogoEditRoute = createRoute({
  getParentRoute: () => teamLogoRoute,
  path: '/$id/edit',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'teams.edit',
      'Takım logosu düzenlemek için yetkiniz yok.'
    )
  },
  head: () => ({
    meta: [{ title: 'Takım Logosu Değiştir' }],
  }),
  component: lazyRouteComponent(
    () => import('@/modules/team-logo/pages/edit-team-logo.page')
  ),
})
